export default __webpack_public_path__ + "media/images/ico-medium-larger-business-fcfad9ac92207ac289cc3a017cb92bf7.svg";